import { db } from 'boot/firebase';
import { collection } from 'firebase/firestore';

import GenericDB from './generic-db';

export default class DataFieldsDB extends GenericDB {
  constructor(clinicId) {
    super('', 'clinicSettings.dataFields');
    this.clinicId = clinicId;
  }

  async setClinicId(clinicId) {
    this.clinicId = clinicId;
  } // setClinicId()

  getCollectionRef() {
    return collection(db, 'clinicSettings', this.clinicId, 'dataFields');
  }
}
